import React from 'react';
import Helmet from 'react-helmet';

import SheetTitle from '../../../components/SheetTitle';
import HelpContactUs from '../../../components/HelpContactUs/HelpContactUs';
import BackButton from '../../../components/BackButton';

import c from '../Help.less';

export default function RequestRefund() {
  return (
    <div className={c.content}>
      <Helmet defer={false}>
        <meta property="mc:dp" content="/shop/help/request-refund" />
      </Helmet>
      <BackButton to="/shop/help" />
      <SheetTitle title="Request a refund" />
      <h4>Refund on my balance</h4>
      <p>
        We offer a possibility of refund for single purchased tracks.
        <br />
        <strong>Possible refund reasons:</strong>
      </p>
      <ul>
        <li>
          the track it faulty and there is no way to currently fix it
          <br />
          If you found a faulty recording, please send us a damaged file notice and we will run it for errors.
        </li>
        <li>
          you purchased a track or a release by mistake This option can be used no more than once per month. Thank you
          for your understanding.
        </li>
      </ul>

      <h4>Refund to my bank account</h4>
      <p>
        We offer a possibility of a refund on your bank account.
        <br />
        It is only possible to refund <strong>the whole amount of the deposit.</strong>
        <br />
        Only the payments made <strong>no longer than 6 months ago</strong> can be refunded.
        <br />
      </p>

      <HelpContactUs subject={1} />
    </div>
  );
}
